const ReportContentLayout = ({ title, children }) => {
  return (
    <section className="card border-0 shadow-sm bg-white mb-4">
      <div className="hero-gradient-bg mb-1 p-3">
        <h2 className="reports-hero-title mb-0 fw-bold">{title}</h2>
      </div>

      <div className="reports-description text-muted">
        {children}
      </div>
    </section>
  );
};

export default ReportContentLayout;
